'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { getMeasurementId, initializeGACustomEvents } from '@/lib/utils/analytics';

export default function GoogleAnalytics() {
  const measurementId = getMeasurementId();

  // Initialize custom events after GA loads
  useEffect(() => {
    const handleGALoad = () => {
      if ((window as any).gtag) {
        initializeGACustomEvents();
      }
    };

    // Check if GA is already loaded
    if ((window as any).gtag) {
      handleGALoad();
    } else {
      // Otherwise wait for it to load
      window.addEventListener('gtag-loaded', handleGALoad);
      return () => window.removeEventListener('gtag-loaded', handleGALoad);
    }
  }, []);

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
        strategy="afterInteractive"
        onLoad={() => {
          // Dispatch event when GA loads
          const event = new Event('gtag-loaded');
          window.dispatchEvent(event);
        }}
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            send_page_view: false, // Disable automatic page views
            debug_mode: ${process.env.NEXT_PUBLIC_APP_ENV !== 'production'}, // Enable debug mode in non-production
          });
        `}
      </Script>
    </>
  );
}